// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__EG9Qs","left":"Main_left__3Dzp5","right":"Main_right__2QF6E"};